import React from 'react';
import { AnchorText, Container, Section } from '../../common';

const FooterUtility = ({ sanity, page }) => {
  const { business, colors } = sanity;
  const { gbp } = page;
  const currentYear = new Date().getFullYear();

  const baseCopyright =
    business?.yearOpened === currentYear.toString()
      ? `© ${currentYear} ${gbp?.name},`
      : `© ${business?.yearOpened} - ${currentYear} ${gbp?.name},`;

  return (
    <Section
      idName="footer-utility"
      bgColor={colors?.neutral?.darker}
      padding="sm"
      classes="border-t border-zinc-200"
    >
      <Container padding="sm">
        <p className="pb-2 text-sm text-center lg:text-base text-zinc-200 lg:pb-0">
          {baseCopyright}{' '}
          <span className="whitespace-nowrap">All Rights Reserved</span>
        </p>
        <p className="text-sm text-center text-zinc-200">
          <AnchorText
            sanity={sanity}
            type="internal"
            color={colors?.accent?.light}
            colorHover={colors?.accent?.lighter}
            to="privacy"
          >
            Privacy Policy
          </AnchorText>{' '}
          |{' '}
          <AnchorText
            sanity={sanity}
            type="internal"
            color={colors?.accent?.light}
            colorHover={colors?.accent?.lighter}
            to="accessibility"
          >
            Accessibility Statement
          </AnchorText>{' '}
          |{' '}
          <AnchorText
            sanity={sanity}
            type="internal"
            color={colors?.accent?.light}
            colorHover={colors?.accent?.lighter}
            to="sitemap"
          >
            Website Sitemap
          </AnchorText>
        </p>
        {business?.license && (
          <p className="mt-2 text-xs text-center text-zinc-200">
            License Number: {business?.license}
          </p>
        )}
      </Container>
    </Section>
  );
};

export { FooterUtility };
